const algorithmFormPageTranslations = {
  0: {
    preMessage:
      "Hey, i will be asking you some questions which will help us craft a fully customized program.",
    message:
      "Well, initially we need to know some basic questions e.g.(Age, Weight, Height & Body Fat Percentage)",
    intro: "Kindly, fill out the details below.",
    age: "Age",
    weight: "Weight",
    height: "Height",
    bodyFat: "Body Fat",
    seeReferenceImage: "See visual reference",
    bodyFatHelpButton: "Help me estimate my body fat",
    waist: "Waist (cm)",
    neck: "Neck (cm)",
    hip: "Hip (cm) – if female",
    calculateBF: "Calculate Body Fat",
    hint: "Enter your measurements to estimate your body fat accurately.",
    measurements_required: "Please enter required measurements first.",
  },
  1: {
    preMessage: "It's time to know more about you",
    message:
      "Please upload your in-body, and also your body photos if possible.",
  },
  2: {
    preMessage: "",
    message:
      "Now, let's get deeper into your nutrition goals. Choose what matches your body transformation target.",
    intro:
      "Make sure to accurately choose your goal, since it directly impacts the program accuracy ✌️.",
    nutritionGoal: "Nutrition Goal",

    // Weight Loss Goals
    slimDownMild: "Slim Down (Mild)",
    weightLossStandard: "Weight Loss (Standard)",
    rapidFatLoss: "Rapid Fat Loss (Extreme)",

    // Balanced Goals
    maintainBalance: "Maintain & Balance",
    bodyRecomposition: "Body Recomposition",
    performanceSupport: "Performance Support",

    // Weight Gain Goals
    leanGainMild: "Lean Gain (Mild)",
    muscleGainStandard: "Muscle Gain (Standard)",
    bulkUpExtreme: "Bulk Up (Extreme)",
  },

  3: {
    preMessage: "",
    message:
      "Tell us more about the ingredients you don't love or have problems with.",
  },
  4: {
    preMessage: "",
    message:
      "Please choose your appropriate activity level in your day to day life.",
    activityLevel: "Activity Level",
    sedentary: "Sedentary (Little to no exercise)",
    lightlyActive: "Light (1-3 days of exercise)",
    moderatelyActive: "Moderate (3-5 days of exercise)",
    veryActive: "Active (6-7 days of exercise)",
    extraActive: "Athlete (Twice daily intense exercise)",
  },
  5: {
    preMessage: "",
    message: "Now, tell me more about your prefered number of meals per day",
    intro: "Kindly, fill out the details below.",
  },
  6: {
    preMessage:
      "Cool 😍, we are done with the nutrition questions. Let's switch to the workout questions.",
    message: "How many days per week you train ?!.",
  },
  7: {
    preMessage: "",
    message: "How is your experience level, please be honest about it.",
    experienceLevel: "Experience Level",
    beginner: "Beginner",
    intermediate: "Intermediate",
    advanced: "Advanced",
  },
  8: {
    preMessage:
      "In case you have medical issues, please provide us with all medical diagnoses or even injuries diagnoses",
    message:
      "Kindly upload your medical or injuries diagnoses if you have any.",
  },
  9: {
    preMessage: "",
    message:
      "Great we are done for now !, But if you wish to add more notes feel free to write it down.",
    notes: "Notes",
  },
};

export default algorithmFormPageTranslations;
